import {
  createGlobalConfig,
  panoramaClientFactory,
  PanoramaPlatform,
} from '@wix/panorama-client-web';
import * as Sentry from '@sentry/browser';
import { SENTRY_DSN } from '../constants/sentryDSN';

export const panoramaGlobalConfig = createGlobalConfig();

export const initPanoramaClient = () => {
  const panoramaFactory = panoramaClientFactory({
    baseParams: {
      platform: PanoramaPlatform.Standalone,
      fullArtifactId: 'com.wixpress.app-templates-page',
      componentId: 'app-templates-page',
      uuid: (window as any).__USER_ID__ || '', // Optional
    },
    pluginParams: {
      sentry: Sentry,
      sentryDsn: SENTRY_DSN,
    },
  }).withGlobalConfig(panoramaGlobalConfig);
  return panoramaFactory.client();
};
